((Drupal) => {
  "use strict";

  const activeNavigationLinks = (context) => {
    const { schoolExams } = drupalSettings;
    const userRoles = schoolExams?.userRoles || {};
    const { isTeacher, isStudent, isIndividual } = userRoles;

    // Adds an 'active' class to the specified selector and its parent element.
    // If no dropdowns exist in the context, removes the facets widget dropdown.
    const addActiveClass = (selector, context) => {
      const element = context.querySelector(selector);
      if (element) {
        element.classList.add("active");
        const parent = element.parentElement;
        if (parent) {
          parent.classList.add("active");
        }
      }

      const dropdowns = context.querySelectorAll(
        ".facets-widget-dropdown > ul"
      );
      if (dropdowns.length < 1) {
        const facetsWidgetDropdown = context.querySelector(
          ".facets-widget-dropdown"
        );
        facetsWidgetDropdown?.remove();
      }
    };

    // Compares the current path with an array of link paths.
    // If the current path includes any of the links, it applies the 'active' class to the target element.
    const comparePath = (linkArray, path) => {
      const currentPath = window.location.pathname;
      if (linkArray.some((link) => currentPath.includes(link))) {
        addActiveClass(path, context);
      }
    };

    // Define a list of paths that may be matched with the current URL.
    const links = [
      "/my-lists",
      "/plan/modules",
    ];

    // Activates navigation link based on the user's role.
    const activateRoleBasedNavigation = () => {
      if (isTeacher) {
        comparePath(links, '[data-drupal-link-system-path="plan/modules"]');
      }
    };

    activateRoleBasedNavigation();
  };

  // Manage active navigation links based on user roles and paths.
  Drupal.behaviors.activeNavigationLinks = {
    attach(context) {
      activeNavigationLinks(context);
    },
  };
})(Drupal);
